<template>
  <div class="terms">
    By proceeding, you agree to our <a href="https://iconicmoments.co/iconic-licensing-agreement">Terms &amp; Conditions</a>
  </div>
</template>

<style lang="scss">
.terms {
  a {
    color: var(--color-primary-one);
  }
  margin: 1em 0;
  font-size: .9em;
}
</style>